import React, { useContext, useEffect, useState } from 'react'
import { Box, Button, Checkbox, Container, createTheme, FormControlLabel, Grid, IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ThemeProvider, Tooltip, Typography } from '@mui/material';
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextNotification, severitys } from '../../../App';
import RtlProvider from '../../../Components/RtlProvider';


import { EmailRegex } from '../../../Regex';
import staticVariablesApi from '../../../api/staticVariablesApi';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import { MdAdd, MdCardGiftcard, MdClose, MdDelete, MdOutlineFileDownload, MdPersonAdd, MdPlusOne } from 'react-icons/md';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import guestGroupApi from '../../../api/guestGroupApi';
import Loading from '../../../Components/Loading';
import GuestFileInput from './GuestFileInput';
import { triggerBase64Download } from 'common-base64-downloader-react';
import { FaPassport } from 'react-icons/fa';
import fileAttachmentApi from '../../../api/fileAttachmentApi';
import PdfView from "../../../Components/PdfView";

import { useNavigate } from 'react-router-dom';
import enumMapper from '../../../enumMapper';
import { ContextUserInfo } from '../MainPanel';

import '../../../Styles/Guest.css'
import PassengerInfo from './PassengerInfo';
import AddMemberToGroup from './AddMemberToGroup';
import { FaDownload, FaStamp, FaUserPlus } from 'react-icons/fa6';
import DeleteAttachment from './DeleteAttachment';


const CreateGuestGroup = () => {
    const { open, setOpen } = useContext(ContextNotification);
    const { userInfo, userPermissions, userRoles } = React.useContext(ContextUserInfo);
    const [category, setCategory] = useState(null)
    const [ageTypeArabianDropDown, setAgeTypeArabianDropDown] = React.useState([])
    const [degreeOfRelativityDropDown, setDegreeOfRelativityDropDown] = React.useState([])
    const [parentPassNODropdown, setParentPassNODropdown] = React.useState([])
    const [previewLoading, setPreviewLoading] = useState(false);
    const [openPassengerModal, setOpenPassengerModal] = useState(false);
    const [openAddMemberToGroupModal, setOpenAddMemberToGroupModal] = useState(false);
    const [selectedPassenger, setSelectedPassenger] = useState(null);
    const [openAttachmentPreview, setOpenAttachmentPreview] = useState(false);
    const [attachmentLoading, setAttachmentLoading] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    
    const navigate = useNavigate();


    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const [Stepper, setStepper] = useState(1);
    const [EnablePre, setEnablepre] = useState(false);

    const primarySchema = yup.object({
        name: yup.string().required("نام را وارد کنید"),
        family: yup.string().required("نام خانوادگی را وارد کنید"),
        passNO: yup.string().required("شماره گذرنامه را وارد کنید").max(10, "حداکثر 10 رقم وارد نمایید"),
        fatherName: yup.string().required("نام پدر را وارد نمایید"),
        mBirthDate: yup.string().required("تاریخ تولد را وارد کنید"),
        ageCategory: yup.string().required("گروه سنی را انتخاب نمایید"),
        address: yup.string().required("آدرس محل سکونت را وارد کنید"),
        emailAddress: yup.string().trim().required("ایمیل را وارد نمایید").matches(EmailRegex, { message: "فرمت ایمیل صحیح نیست" }),
        ssn: yup.string().nullable().max(10, "10 رقم وارد نمایید").trim()
            .test("SSNValidaton", "کد ملی صحیح نیست", (value) => SSNValidator(value)),
        mobileNO: yup.string().nullable().max(11, "حداکثر 11 رقم وارد نمایید")
    })
    const primarySchema2 = yup.object({
    })

    const secondarySchema = yup.object({
        name: yup.string().required("نام را وارد کنید"),
        family: yup.string().required("نام خانوادگی را وارد کنید"),
        passNO: yup.string().required("شماره گذرنامه را وارد کنید").max(10, "حداکثر 10 رقم وارد نمایید"),
        fatherName: yup.string().required("نام پدر را وارد نمایید"),
        mBirthDate: yup.string().required("تاریخ تولد را وارد کنید"),
        ageCategory: yup.string().required("گروه سنی را انتخاب نمایید"),
        address: yup.string().required("آدرس محل سکونت را وارد کنید"),
        ssn: yup.string().nullable().max(10, "10 رقم وارد نمایید").trim()
            .test("SSNValidaton", "کد ملی صحیح نیست", (value) => SSNValidator(value)),
        mobileNO: yup.string().nullable().max(11, "حداکثر 11 رقم وارد نمایید")
    })

    const secondarySchema2 = yup.object({

    })

    const validationSchema = yup.object({
        firstArray: yup.array().of(
            yup.lazy((item) => {
                switch (item?.type) {
                    case "primary":
                        return primarySchema;
                    case "secondary":
                        return secondarySchema;
                    default:
                        return yup.mixed().notRequired();
                }
            })
        ),
        secondArray: yup.array().of(
            yup.lazy((item) => {
                switch (item?.type) {
                    case "primary":
                        return primarySchema2;
                    case "secondary":
                        return secondarySchema2;
                    default:
                        return yup.mixed().notRequired();
                }
            })
        )
    })

    const { register, control, handleSubmit, reset, formState, watch, setValue, getValues, trigger, clearErrors } = useForm(
        {
            defaultValues: {
                firstArray: [],
                secondArray: []
            },
            resolver: yupResolver(validationSchema),
            mode: "onChange",
            reValidateMode: "onChange"
        }
    );
    const { errors } = formState;
    const firstArrayGuests = useFieldArray({ name: 'firstArray', control });
    const secondArrayGuests = useFieldArray({ name: 'secondArray', control });

    const useWatchSecondArray = useWatch({
        control,
        name: `secondArray`
    })

    useEffect(() => {
        guestGroupApi.GetGroupInfo()
            .then(res => {
                setCategory(res.data.data)
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false))
    }, [refresh])

    useEffect(() => {
        GetAgeTypeArabianDropDown();
        GetDegreeOfRelativityDropDown();
    }, [])

    useEffect(() => {
        if (firstArrayGuests.fields.length === 0) {
            firstArrayGuests.append({
                type: "primary",
                name: userInfo?.firstName,
                family: userInfo?.lastName,
                passNO: userInfo?.username,
                ageCategory: enumMapper.AgeTypeArabian.adult.toString(),
                degreeOfRelativity: enumMapper.DegreeOfRelativity.agent,
                isParent: true
            });
        }
    }, [firstArrayGuests.fields.length]);

    useEffect(() => {
        if (Stepper > 1) {
            setEnablepre(false);
        } else {
            setEnablepre(true);
        }
    }, [Stepper]);
    function populateDate(date) {
        let mBirthDateGregorian = null;
        let mBirthDate = new DateObject({
            date: date,
            calendar: persian,
            locale: persian_fa
        });

        var dateStr = date.year + '/' + date.month.number + '/' + date.day;
        // dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        return dateStr
    }
    function populateAgeCategory(ageCategory) {
        let ageCategoryTitle = "";
        switch (ageCategory) {
            case 1:
                ageCategoryTitle = "بالای 12 سال"
                break;
            case 2:
                ageCategoryTitle = "7 تا 12 سال"
                break;
            case 3:
                ageCategoryTitle = "2 تا 7 سال"
                break;
            case 4:
                ageCategoryTitle = "زیر 2 سال"
                break;
            case 99:
                ageCategoryTitle = "نامشخص"
                break;
            default:
                break;
        }
        return ageCategoryTitle;

    }
    const handleNext = async (data) => {
        const isValid = await trigger("firstArray");
        if (!isValid) return;
        //setSubmitLoading(true);
        const first = getValues("firstArray")
        const hasDuplicatePassNo = new Set(first.map(o => o.passNO)).size !== first.length;
        if (hasDuplicatePassNo) {
            setOpen({ IsEnable: true, Message: "شماره گذر تکراری در لیست وجود دارد", severity: severitys.error });
            return;
        }
        GetParentPassNODropdown();
        const second = first.map(u => (
            {
                "type": u.type,
                "name": u.name,
                "family": u.family,
                "fatherName": u.fatherName,
                "ssn": u.ssn,
                "passNO": u.passNO,
                "mBirthDate": u.mBirthDate,
                "ageCategory": u.ageCategory,
                "emailAddress": u.emailAddress,
                "mobileNO": u.mobileNO,
                "address": u.address,
                "parentPassNO": u.parentPassNO,
                "degreeOfRelativity": u.degreeOfRelativity,
                "isParent": u.isParent
            }))
        secondArrayGuests.replace(second);
        setStepper((old) => old + 1);
    }

    const onSubmit = (data) => {
        let array = data.secondArray;
        let populatedArray = []
        for (let index = 0; index < array.length; index++) {
            const element = array[index];

            let mBirthDateGregorian = null;
            let mBirthDate = new DateObject({
                date: element.mBirthDate,
                calendar: persian,
                locale: persian_fa
            });

            var mBirthDateStr = mBirthDate.year + '/' + mBirthDate.month.number + '/' + mBirthDate.day;
            mBirthDateGregorian = moment.from(mBirthDateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')

            populatedArray.push({
                "name": element.name,
                "family": element.family,
                "fatherName": element.fatherName,
                "ssn": element.ssn,
                "passNO": element.passNO,
                "mBirthDate": mBirthDateGregorian,
                "mBirthDatePersian": mBirthDateStr,
                "ageCategory": parseInt(element.ageCategory),
                "emailAddress": element.emailAddress,
                "mobileNO": element.mobileNO,
                "address": element.address,
                "parentPassNO": element.parentPassNO,
                "degreeOfRelativity": parseInt(element.degreeOfRelativity),
                "isParent": element.isParent,
            })
        }

        guestGroupApi.CustomCreate(populatedArray)
            .then(res => {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                    setRefresh(old => !old)
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                }
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
                else {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                }
            }
            ).finally(() => { });

    };


    const resetForm = () => {
    }

    const GetAgeTypeArabianDropDown = () => {
        staticVariablesApi.GetAgeTypeArabianDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setAgeTypeArabianDropDown(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };
    const handleAgeTypeArabianChanged = (id) => { }
    const GetDegreeOfRelativityDropDown = () => {
        staticVariablesApi.GetDegreeOfRelativityDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setDegreeOfRelativityDropDown(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };
    const handleDegreeOfRelativityChanged = (id) => { }
    const GetParentPassNODropdown = () => {
        const first = getValues("firstArray")
        const arr = first.map(u => ({
            id: u.passNO,
            label: u.passNO
        }))
        setParentPassNODropdown(arr)

    }
    const handleParentPassNOChanged = () => { }
    const handlePrev = () => {
        clearErrors("firstArray")
        clearErrors("secondArray")
        setStepper((old) => old - 1);

        const second = getValues("secondArray")
        const first = second.map(u => ({
            "type": u.type,
            "name": u.name,
            "family": u.family,
            "fatherName": u.fatherName,
            "ssn": u.ssn,
            "passNO": u.passNO,
            "mBirthDate": u.mBirthDate,
            "ageCategory": u.ageCategory,
            "emailAddress": u.emailAddress,
            "mobileNO": u.mobileNO,
            "address": u.address,
            "parentPassNO": u.parentPassNO,
            "degreeOfRelativity": u.degreeOfRelativity,
            "isParent": u.isParent
        }))
        firstArrayGuests.replace(first);


    };

    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
        handleCloseAddMemberToGroupModal();
        handleCloseAttachmentPreview();
    }
    const SSNValidator = (val) => {
        if (!val)
            return true;
        else
            return helper.SSNValidator(val)
    }
    const handleGuestRequest = (id) => {
        guestGroupApi.CompletedPassportImageFileForGuestGroup(id).then(res => {
            if (res.data.success) {
                navigate("/Dashboard/GuestRequest/Add");
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
                else {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                }
            }
            ).finally(() => { });
    };

    const handleOpenPassengerModal = (passenger) => {
        setSelectedPassenger(passenger);
        setOpenPassengerModal(true);
    };
    const handleClosePassengerModal = () => {
        setSelectedPassenger(null);
        setOpenPassengerModal(false);
    };

    const handleOpenAddMemberToGroupModal = (category) => {

        setOpenAddMemberToGroupModal(true);
    };
    const handleCloseAddMemberToGroupModal = () => {

        setOpenAddMemberToGroupModal(false);
    };


  const handleOpenAttachmentPreview = (e, type) => {
    setAttachmentLoading(true);
    setOpenAttachmentPreview(true);
    fileAttachmentApi.GetPassengerFiles(e?.id).then((res) => {
      if (res.data.success) {
        let obj={
            ownerId:e?.id,
            ...res.data.data[0]
        }
        setPreviewData(obj);
      }
      else {

      }
    }).catch(err => console.log(err)).finally(() => setAttachmentLoading(false))

  };
  const getExtention = (attachment) => {
    return attachment?.fileName?.substring(attachment?.fileName?.lastIndexOf(".") + 1);
  }
  const handleCloseAttachmentPreview = () => {
    setPreviewData(null)
    setOpenAttachmentPreview(false)
  };


  const handleTriggerPassFile = (previewData) => {
    triggerBase64Download('data:' + previewData.contentType + ";base64," + previewData.fileBase64, previewData.fileName)
  }

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: 350, sm: 450 },
        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: 24,
        p: 4,
    };


  const imgModalStyle = {
    // position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // maxWidth: 700,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    // p: 1,
    minWidth:'400px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflow: 'scroll',
    height: '100%',
    display: 'block'

  }
  const pdfModalStyle = {
    minWidth:'400px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflow: 'scroll',
    height: '100%',
    display: 'block'
  };

    return (
        <Container maxWidth={false} >
            <RtlProvider>
                {
                    loading ? <Loading /> : <Box>
                        {
                            category ?
                                <Box sx={{ p: 3 }}>
                                     <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        <Button
            variant="contained"
            startIcon={<MdOutlineFileDownload />}
            href="/files/GozarScan-help.pdf"
            download="راهنمای ارسال اسکن گذرنامه.pdf"
        >
            دانلود راهنمای گذرنامه
        </Button>
                                    
        <Button
            variant="outlined"
            startIcon={<FaUserPlus />}
            onClick={() => handleOpenAddMemberToGroupModal(category)}
        >
            افزودن عضو به گروه
        </Button>
    </Box>

                                    {/* 📋 جدول اعضا */}
                                    <TableContainer component={Paper} sx={{ maxHeight: 450 }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: "#f3f3f3" }}>
                                                    <TableCell>نام</TableCell>
                                                    <TableCell>نام خانوادگی</TableCell>
                                                    <TableCell>نام پدر</TableCell>
                                                    <TableCell>شماره گذرنامه</TableCell>
                                                    <TableCell align="center">گذرنامه</TableCell>
                                                    <TableCell align="center">عملیات</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {category?.allMembers?.map((member) => (
                                                    <TableRow key={member.id} hover>
                                                        <TableCell>{member.name}</TableCell>
                                                        <TableCell>{member.family}</TableCell>
                                                        <TableCell>{member.fatherName}</TableCell>
                                                        <TableCell>{member.passNO}</TableCell>

                                                        <TableCell align="center">
                                                            {!member.hasPassportImage ? (
                                                                <GuestFileInput
                                                                    fileAttachmentType="PassportImage"
                                                                    guestPassengerId={member.id}
                                                                    refreshGrid={RefreshGrid}
                                                                />
                                                            ) : previewLoading ? (
                                                                <Loading />
                                                            ) : (
                                                                // <Tooltip title="دانلود تصویر گذرنامه">
                                                                //     <IconButton onClick={(e) => handleTrigger(e, member)}>
                                                                //         <FaPassport size={20} color="#6A5ACD" />
                                                                //     </IconButton>
                                                                // </Tooltip>
                                                                <Tooltip title="تصویر گذرنامه">
                                                                <IconButton onClick={() => { handleOpenAttachmentPreview(member) }}>
            <FaPassport size="20px" color='#6A5ACD' />
          </IconButton>
          </Tooltip>
                                                            )}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <Button variant="contained" size="small" onClick={() => handleOpenPassengerModal(member)}>
                                                                جزئیات بیشتر
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Box sx={{ mt: 3 }}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => handleGuestRequest(category.id)}
                                        >
                                            ثبت درخواست
                                        </Button>
                                    </Box>
                                </Box> :
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {
                                        Stepper === 1 && <>
                                            {firstArrayGuests.fields.map((field, index) => (
                                                <div key={field.id}>
                                                    {index === 0 ? (
                                                        <>
                                                            <div className='guest-passenger-box'>
                                                                <Typography variant='h6' sx={{ mb: 2 }}>اطلاعات سرگروه</Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام"
                                                                            {...register(`firstArray.${index}.name`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            disabled
                                                                            error={!!errors.firstArray?.[index]?.name}
                                                                            helperText={errors.firstArray?.[index]?.name?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام خانوادگی"
                                                                            {...register(`firstArray.${index}.family`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            disabled
                                                                            error={!!errors.firstArray?.[index]?.family}
                                                                            helperText={errors.firstArray?.[index]?.family?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="شماره گذرنامه"
                                                                            {...register(`firstArray.${index}.passNO`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },


                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            disabled
                                                                            error={!!errors.firstArray?.[index]?.passNO}
                                                                            helperText={errors.firstArray?.[index]?.passNO?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام پدر"
                                                                            {...register(`firstArray.${index}.fatherName`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.fatherName}
                                                                            helperText={errors.firstArray?.[index]?.fatherName?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <Controller
                                                                            control={control}
                                                                            name={`firstArray.${index}.mBirthDate`}
                                                                            rules={{ required: true }}
                                                                            render={({
                                                                                field: { onChange, name, value },
                                                                                fieldState: { invalid, isDirty },
                                                                            }) => (
                                                                                <>
                                                                                    <DatePicker
                                                                                        value={value || ""}
                                                                                        onChange={(date) => {
                                                                                            onChange(date?.isValid ? date : "");
                                                                                        }}
                                                                                        format={"YYYY/MM/DD"}
                                                                                        calendar={persian}
                                                                                        locale={persian_fa}
                                                                                        calendarPosition="bottom-right"
                                                                                        render={<CustomDateInput label={"تاریخ تولد"}
                                                                                            sx={{
                                                                                                "& .MuiInputBase-root": {
                                                                                                    padding: 0,
                                                                                                },
                                                                                                "& .MuiOutlinedInput-root": {
                                                                                                    height: 40
                                                                                                },
                                                                                                "& .MuiInputBase-input": {
                                                                                                    padding: "0 14px",
                                                                                                    lineHeight: "40px"
                                                                                                }
                                                                                            }}
                                                                                            error={!!errors.firstArray?.[index]?.mBirthDate}
                                                                                            helperText={errors.firstArray?.[index]?.mBirthDate?.message}
                                                                                        />}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="ایمیل"
                                                                            {...register(`firstArray.${index}.emailAddress`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },


                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.emailAddress}
                                                                            helperText={errors.firstArray?.[index]?.emailAddress?.message}
                                                                        />
                                                                    </Grid>


                                                                    <Grid item md={4}>
                                                                        <RHFAutocomplete
                                                                            control={control}
                                                                            options={ageTypeArabianDropDown ?? []}
                                                                            name={`firstArray.${index}.ageCategory`}
                                                                            placeholder="گروه سنی"
                                                                            onChange={handleAgeTypeArabianChanged}
                                                                            style={{
                                                                                border: "none",
                                                                                padding: 0
                                                                            }}
                                                                            sx={
                                                                                {
                                                                                    "& .MuiInputBase-root": {
                                                                                        padding: 0,


                                                                                    },
                                                                                    "& .MuiOutlinedInput-root": {
                                                                                        height: 40,
                                                                                        minWidth: 185
                                                                                    },
                                                                                    "& .MuiInputBase-input": {
                                                                                        padding: "0 14px",
                                                                                        lineHeight: "40px",

                                                                                    }
                                                                                }
                                                                            }
                                                                            error={!!errors.firstArray?.[index]?.ageCategory}
                                                                            helperText={errors.firstArray?.[index]?.ageCategory?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="کد ملی (اختیاری)"
                                                                            {...register(`firstArray.${index}.ssn`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },


                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.ssn}
                                                                            helperText={errors.firstArray?.[index]?.ssn?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="شماره موبایل (اختیاری)"
                                                                            {...register(`firstArray.${index}.mobileNO`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.mobileNO}
                                                                            helperText={errors.firstArray?.[index]?.mobileNO?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={12}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="آدرس محل سکونت"
                                                                            {...register(`firstArray.${index}.address`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.address}
                                                                            helperText={errors.firstArray?.[index]?.address?.message}
                                                                        />
                                                                    </Grid>
                                                                </Grid>

                                                            </div>
                                                            {firstArrayGuests.fields.length > 1 && <Typography variant='h6' sx={{ mb: 2 }}>اطلاعات همراهان</Typography>}
                                                        </>
                                                    ) : (
                                                        <div class="guest-passenger-box child-guest-passenger-box">
                                                            <Tooltip title="حذف همراه" placement="top">
                                                                <Button class="delete-btn" aria-label="Delete" onClick={() => firstArrayGuests.remove(index)}>×</Button>
                                                            </Tooltip>
                                                            <div class="form">
                                                                <Grid container spacing={2}>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام"
                                                                            {...register(`firstArray.${index}.name`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.name}
                                                                            helperText={errors.firstArray?.[index]?.name?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام خانوادگی"
                                                                            {...register(`firstArray.${index}.family`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.family}
                                                                            helperText={errors.firstArray?.[index]?.family?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="شماره گذرنامه"
                                                                            {...register(`firstArray.${index}.passNO`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.passNO}
                                                                            helperText={errors.firstArray?.[index]?.passNO?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="نام پدر"
                                                                            {...register(`firstArray.${index}.fatherName`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },


                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.fatherName}
                                                                            helperText={errors.firstArray?.[index]?.fatherName?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <Controller
                                                                            control={control}
                                                                            name={`firstArray.${index}.mBirthDate`}
                                                                            rules={{ required: true }}
                                                                            render={({
                                                                                field: { onChange, name, value },
                                                                                fieldState: { invalid, isDirty },
                                                                            }) => (
                                                                                <>
                                                                                    <DatePicker
                                                                                        value={value || ""}
                                                                                        onChange={(date) => {
                                                                                            onChange(date?.isValid ? date : "");
                                                                                        }}
                                                                                        format={"YYYY/MM/DD"}
                                                                                        calendar={persian}
                                                                                        locale={persian_fa}
                                                                                        calendarPosition="bottom-right"
                                                                                        render={<CustomDateInput label={"تاریخ تولد"}
                                                                                            sx={{
                                                                                                "& .MuiInputBase-root": {
                                                                                                    padding: 0,
                                                                                                },
                                                                                                "& .MuiOutlinedInput-root": {
                                                                                                    height: 40
                                                                                                },
                                                                                                "& .MuiInputBase-input": {
                                                                                                    padding: "0 14px",
                                                                                                    lineHeight: "40px"
                                                                                                }
                                                                                            }}
                                                                                            error={!!errors.firstArray?.[index]?.mBirthDate}
                                                                                            helperText={errors.firstArray?.[index]?.mBirthDate?.message}
                                                                                        />}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="ایمیل (اختیاری)"
                                                                            {...register(`firstArray.${index}.emailAddress`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,

                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },


                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.emailAddress}
                                                                            helperText={errors.firstArray?.[index]?.emailAddress?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <RHFAutocomplete
                                                                            control={control}
                                                                            options={ageTypeArabianDropDown ?? []}
                                                                            name={`firstArray.${index}.ageCategory`}
                                                                            placeholder="گروه سنی"
                                                                            onChange={handleAgeTypeArabianChanged}
                                                                            style={{
                                                                                border: "none",
                                                                                padding: 0
                                                                            }}
                                                                            sx={
                                                                                {
                                                                                    "& .MuiInputBase-root": {
                                                                                        padding: 0,

                                                                                    },
                                                                                    "& .MuiOutlinedInput-root": {
                                                                                        height: 40,
                                                                                        minWidth: 185
                                                                                    },
                                                                                    "& .MuiInputBase-input": {
                                                                                        padding: "0 14px",
                                                                                        lineHeight: "40px",

                                                                                    }
                                                                                }
                                                                            }
                                                                            error={!!errors.firstArray?.[index]?.ageCategory}
                                                                            helperText={errors.firstArray?.[index]?.ageCategory?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="کد ملی (اختیاری)"
                                                                            {...register(`firstArray.${index}.ssn`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.ssn}
                                                                            helperText={errors.firstArray?.[index]?.ssn?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={4}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="شماره موبایل (اختیاری)"
                                                                            {...register(`firstArray.${index}.mobileNO`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.mobileNO}
                                                                            helperText={errors.firstArray?.[index]?.mobileNO?.message}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item md={12}>
                                                                        <TextField
                                                                            fullWidth
                                                                            placeholder="آدرس محل سکونت"
                                                                            {...register(`firstArray.${index}.address`)}
                                                                            sx={{
                                                                                "& .MuiInputBase-root": {
                                                                                    padding: 0,
                                                                                },
                                                                                "& .MuiOutlinedInput-root": {
                                                                                    height: 40
                                                                                },
                                                                                "& .MuiInputBase-input": {
                                                                                    padding: "0 14px",
                                                                                    lineHeight: "40px"
                                                                                }
                                                                            }}
                                                                            error={!!errors.firstArray?.[index]?.address}
                                                                            helperText={errors.firstArray?.[index]?.address?.message}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            <div style={{ display: 'flex', gap: 15 }}>
                                                <Button

                                                    variant='outlined'
                                                    type="button"
                                                    onClick={() => firstArrayGuests.append({ type: "secondary", isParent: false })}
                                                    sx={{ whiteSpace: 'nowrap' }} startIcon={<MdAdd />}
                                                >
                                                    افزودن همراه
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    onClick={handleNext}
                                                >
                                                    تأیید
                                                </Button>
                                            </div>
                                        </>
                                    }
                                    {
                                        Stepper === 2 && <Box>
                                            <TableContainer component={Paper} sx={{ borderRadius: 1 }}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                                            <TableCell align="center">نام</TableCell>
                                                            <TableCell align="center">نام خانوادگی</TableCell>
                                                            <TableCell align="center">نام پدر</TableCell>
                                                            <TableCell align="center">شماره گذرنامه</TableCell>
                                                            <TableCell align="center">تاریخ تولد</TableCell>
                                                            <TableCell align="center">گروه سنی</TableCell>
                                                            <TableCell align="center">ایمیل</TableCell>
                                                            <TableCell align="center">کد ملی</TableCell>
                                                            <TableCell align="center">موبایل</TableCell>
                                                            <TableCell align="center">آدرس</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {secondArrayGuests?.fields.map((field, index) => {
                                                            const {
                                                                id,
                                                                name,
                                                                family,
                                                                fatherName,
                                                                passNO,
                                                                mBirthDate,
                                                                ageCategory,
                                                                emailAddress,
                                                                ssn,
                                                                mobileNO,
                                                                address,
                                                            } = field;

                                                            return (
                                                                <TableRow
                                                                    key={id || index}
                                                                    hover
                                                                    sx={{
                                                                        "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                                                                    }}
                                                                >
                                                                    <TableCell align="center">{name}</TableCell>
                                                                    <TableCell align="center">{family}</TableCell>
                                                                    <TableCell align="center">{fatherName}</TableCell>
                                                                    <TableCell align="center">{passNO}</TableCell>
                                                                    <TableCell align="center">
                                                                        {populateDate(mBirthDate)}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {populateAgeCategory(parseInt(ageCategory))}
                                                                    </TableCell>
                                                                    <TableCell align="center">{emailAddress}</TableCell>
                                                                    <TableCell align="center">{ssn}</TableCell>
                                                                    <TableCell align="center">{mobileNO}</TableCell>
                                                                    <TableCell align="center">{address}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <div style={{ marginTop: 10 }}>
                                                <Button
                                                    onClick={() => {
                                                        handlePrev();
                                                    }
                                                    }
                                                    variant='outlined'
                                                    sx={{ m: 2 }}
                                                >
                                                    قبلی
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant='contained'
                                                >
                                                    تأیید نهایی
                                                </Button>
                                            </div>
                                        </Box>
                                    }
                                </form>
                        }
                    </Box>
                }
            </RtlProvider>

            {/* Edit Request Modal */}
            <Modal
                keepMounted
                open={openPassengerModal}
                onClose={handleClosePassengerModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        جزئیات بیشتر
                    </Typography>
                    <Box sx={{ mt: 4 }}>
                        {selectedPassenger && <PassengerInfo id={selectedPassenger?.id} />}
                    </Box>
                </Box>
            </Modal>

            <Modal
                keepMounted
                open={openAddMemberToGroupModal}
                onClose={handleCloseAddMemberToGroupModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: 350, sm: 650 },
                    bgcolor: "background.paper",
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        افزودن عضو به گروه                    </Typography>
                    <Box sx={{ mt: 4 }}>
                        {category && ageTypeArabianDropDown && <AddMemberToGroup category={category} ageTypeArabianDropDown={ageTypeArabianDropDown} refreshGrid={RefreshGrid}/>}
                    </Box>
                </Box>
            </Modal>

                  <Modal
        open={openAttachmentPreview}
        onClose={handleCloseAttachmentPreview}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={getExtention(previewData) === "pdf" ? pdfModalStyle : imgModalStyle}>
          <Tooltip title="بستن" placement="top">
            <IconButton onClick={handleCloseAttachmentPreview}>
              <MdClose style={{ color: '#4a148c' }} />
            </IconButton>
          </Tooltip>
          {
            previewLoading ? 'لطفا منتظر بمانید...' : <><Tooltip title="دانلود گذرنامه" placement="top">
              <IconButton onClick={() => handleTriggerPassFile(previewData)}>
                <FaDownload size="20px" color='#80489C' />
              </IconButton>
            </Tooltip>
            <DeleteAttachment
                                      id={previewData?.id}
                                      refreshGrid={RefreshGrid}
                                    />

            </>
          }
          

          <div dir='rtl' style={{ textAlign: 'center' }}>
            {
              getExtention(previewData) === "pdf" ?
                attachmentLoading ? <Loading /> : <PdfView base64={`data:application/pdf;base64,${previewData?.fileBase64}`} /> :
                attachmentLoading ? <Loading /> : <img src={`data:img/png;base64,${previewData?.fileBase64}`} className='responsive-img' />
            }
          </div>
        </Box>
      </Modal>


        </Container>
    )
}

export default CreateGuestGroup